const LISTAR_DADOS = (state, payload) => {
    // Garante que sempre armazena um array
    state.items = Array.isArray(payload) ? payload : (payload?.data || [])
}

const LISTAR_TAREFAS_DESTINO = (state, payload) => {
  // Garante que sempre armazena um array
  state.tarefasDestino = Array.isArray(payload) ? payload : (payload?.data || [])
}

const CARREGANDO = (state, payload) => {
  state.carregando = payload
}

const INSERIR_TAREFA_MOBILIDADE_SELECIONADA = (state,  payload) => {
  state.selecionado = payload
}

const INSERIR_MOBILIDADE_TAREFA_ORIGEM_SELECIONADA = (state, payload) => {
  state.mobilidadesTarefa = payload
}

const INSERIR_MOBILIDADE_FORMULARIO_SELECIONADA = (state, payload) => {
  state.mobilidadesFormulario = payload
}

const CARREGANDO_MOBILIDADE_FORMULARIO = (state, payload) => {
  state.carregandoMobilidadeFormulario = payload
}

const INSERIR_OPCOES_FORMULARIO_SELECIONADA = (state, payload) => {
  state.opcoesFormulario = payload
}

const CARREGANDO_OPCOES_FORMULARIO = (state, payload) => {
  state.carregandoOpcoesFormulario = payload
}

export {
    LISTAR_DADOS,
    CARREGANDO,
    INSERIR_TAREFA_MOBILIDADE_SELECIONADA,
    LISTAR_TAREFAS_DESTINO,
    INSERIR_MOBILIDADE_TAREFA_ORIGEM_SELECIONADA,
    INSERIR_MOBILIDADE_FORMULARIO_SELECIONADA,
    CARREGANDO_MOBILIDADE_FORMULARIO,
    INSERIR_OPCOES_FORMULARIO_SELECIONADA,
    CARREGANDO_OPCOES_FORMULARIO
}